import { useMemo } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import {
  CoCreationForm,
  CoCreationFormElement,
  QuestionType,
} from '@factorialco/f0-react/dist/experimental'

import {
  FromFormToQuestionnaire,
  FromQuestionnaireToForm,
} from 'modules/forms/components/newFormEditor/helpers'
import { QuestionnaireType } from 'modules/forms/components/newFormEditor/types'

const ALLOWED_QUESTION_TYPES: QuestionType[] = [
  'text',
  'longText',
  'select',
  'multi-select',
  'numeric',
  'link',
  'date',
  'dropdown-single',
]

interface Props {
  state: QuestionnaireType
  setState: (state: QuestionnaireType) => void
}

const NewFormEditor = ({ state, setState }: Props) => {
  const elements = useMemo(
    () =>
      FromQuestionnaireToForm(state.elements, {
        mapDropdownSingleTo: 'dropdown-single',
      }),
    [state.elements]
  )

  const handleChange = (updatedElements: CoCreationFormElement[]) => {
    setState({ ...state, elements: FromFormToQuestionnaire(updatedElements) })
  }

  return (
    <Box flexGrow height="full" padding="s16" paddingBottom="s96">
      <Box gap="s16" width="s600" alignSelf="center" height="full">
        <CoCreationForm
          isEditMode
          elements={elements}
          onChange={handleChange}
          allowedQuestionTypes={ALLOWED_QUESTION_TYPES}
        />
      </Box>
    </Box>
  )
}

export default NewFormEditor
